import { render, staticRenderFns } from "./ExternalDashboardModal.vue?vue&type=template&id=1296b0b0&"
import script from "./ExternalDashboardModal.vue?vue&type=script&lang=js&"
export * from "./ExternalDashboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports